'use strict';

const h = require('phy');
const EnrollmentModal = require('./enrollment_modal');
const SelectLogo = require('./image_logo');

const EducationDesktop = props => {
  const {
    dealProps,
    handleLearnMoreClick,
    learnMoreText,
    savingsText: { education: savingsText },
    titleText,
    withSelectText,
  } = props;

  let containerClassList = '.select-widget';
  let titleClassList = '.select-widget__title';

  if (dealProps.isSlimPricingDeal) {
    containerClassList += '.select-widget_slim';
    if (!dealProps.isTravelBookableDeal) {
      titleClassList += '.select-widget__title_slim';
    }
  }

  const title = h(`h3${titleClassList}#select-widget-title`, titleText);

  const learnMoreLink = h(
    'span.select-widget__learn-more',
    h(
      'a#select-widget-link',
      {
        'data-bhc': 'link:learn-more',
        onClick: handleLearnMoreClick,
      },
      learnMoreText
    )
  );

  return h(
    'div',
    h(
      `div${containerClassList}#select-widget-education`,
      {
        'data-bhw': 'SelectEducationWidget',
        'data-bh-viewport': 'respect',
      },
      title,
      h('hr'),
      h(
        'div#select-widget-details',
        h(SelectLogo, props),
        h(
          'p.select-widget__body',
          h('span.select-widget__savings', `${savingsText} `),
          h('span', withSelectText)
        ),
        learnMoreLink
      )
    ),
    h(EnrollmentModal, props)
  );
};

module.exports = EducationDesktop;
